import { types, flow, Instance, unprotect } from "mobx-state-tree";

export const initialStateChilds = {};

const Child = types.model("ChildDetail", {
  id: types.number,
  schoolId: types.number,
  levelId: types.number,
  levelGroupId: types.maybeNull(types.number),
  firstName: types.string,
  lastName: types.string,
  gender: types.string,
  macAddress: types.maybeNull(types.string),
  photoUrl: types.maybeNull(types.string),
  dateOfBirth: types.string,
  status: types.string,
  isMain: types.boolean,
  permissionId: types.number,
  createdAt: types.string,
  updatedAt: types.string,
});

export const Childs = types
  .model({
    // childSelected
    childSelected: types.maybeNull(Child),
  })
  .actions((self) => ({
    setChildSelected: (child: ChildType) => {
      self.childSelected = child;
    },
  }));

export type ChildType = Instance<typeof Child>;
